import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MultilanguageStore } from '@argo/multilanguage';
import { CommonPhase } from '@argo/common';
import { TranslateModule } from '@ngx-translate/core';
import { 
  ScaModuleTitleComponent,
  ScaCardWorkshopComponent,
  ScaAlertComponent,
  ScaBadgeComponent,
  ScaIconComponent
} from '@argo-dev-components-sca-angular/dev-components-sca';

@Component({
  selector: 'app-multilanguage-test-complete',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    ScaModuleTitleComponent,
    ScaCardWorkshopComponent,
    ScaAlertComponent,
    ScaBadgeComponent,
    ScaIconComponent
  ],
  templateUrl: './multilanguage-test-complete-redesigned.component.html',
  styleUrl: './multilanguage-test-complete-redesigned.component.scss'
})
export class MultilanguageTestCompleteComponent {
  readonly multilang = inject(MultilanguageStore);
  readonly CommonPhase = CommonPhase;
  readonly coverage = 100;

  useResult = '';

  getFlagEmoji(lang: string): string {
    const flags: Record<string, string> = {
      'es': '🇪🇸', 'en': '🇬🇧', 'fr': '🇫🇷', 'de': '🇩🇪', 'it': '🇮🇹', 'pt': '🇵🇹',
      'es-ES': '🇪🇸', 'en-US': '🇺🇸', 'en-GB': '🇬🇧', 'pt-BR': '🇧🇷'
    };
    return flags[lang] || '🌍';
  }

  getLanguageName(lang: string): string {
    const names: Record<string, string> = {
      'es': 'Español', 'en': 'English', 'fr': 'Français', 'de': 'Deutsch', 
      'it': 'Italiano', 'pt': 'Português', 'es-ES': 'Español (España)', 
      'en-US': 'English (US)', 'en-GB': 'English (UK)', 'pt-BR': 'Português (Brasil)'
    };
    return names[lang] || lang;
  }

  changeLanguage(lang: string) {
    this.multilang.use(lang).subscribe({
      next: () => {
        this.useResult = `✅ Idioma cambiado a: ${this.getLanguageName(lang)} (${lang})`;
        setTimeout(() => this.useResult = '', 3000);
      },
      error: (err) => {
        this.useResult = `❌ Error al cambiar idioma: ${err}`;
        setTimeout(() => this.useResult = '', 3000);
      }
    });
  }

  getStoredLanguage(): string {
    if (typeof window !== 'undefined' && window.localStorage) {
      return localStorage.getItem('language') || 'No almacenado';
    }
    return 'N/A (SSR)';
  }
}



